import WebView from "react-native-webview";

type Props = {
  url: string;
};
export default function QRCodeWebView({ url }: Props) {
  const uri = `https://play.cuanto.app/qr?url=${encodeURIComponent(url)}`;
  return <WebView source={{ uri }} />;
}
